<template>
  <th v-if="isHeader">
    <!--  -->
    Actions
  </th>
  <td v-else>
    <div>
      <dropdown>
        <dropdown-action success icon="download" @click="onClickDownload">Download</dropdown-action>
        <dropdown-action success icon="preview" @click="onClickPreview">Preview</dropdown-action>
        <dropdown-action danger icon="delete" @click="onClickDelete">Delete file</dropdown-action>
      </dropdown>
    </div>
  </td>
</template>

<script>
import Dropdown from "./Dropdown";
import DropdownAction from "./DropdownAction";

import TrAction from "./TableRowAction";

import VuetableFieldMixin from "vuetable-2/src/components/VuetableFieldMixin";

export default {
  name: "user-actions",

  props: {
    rowData: Object
  },

  methods: {
    onClickPreview() {
      this.$router.push({
        name: "AdminFilesView",
        params: { id: this.rowData.id }
      });
    },
    onClickDownload() {
      this.$store.dispatch("files/read", this.rowData.id).then(resp => {
        this.$store.dispatch("files/download", resp);
      });
    },
    onClickEdit() {
      this.$router.push({
        name: "AdminFilesEdit",
        params: { id: this.rowData.id }
      });
    },

    onClickDelete() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store
            .dispatch("files/delete", this.rowData.id)
            .then(resp => {
              vm.$store.dispatch("notifications/create", {
                body: "The file has been deleted",
                type: "success"
              });
              this.$store.dispatch('files/list')
            })
            .catch(err => {
              vm.$store.dispatch("notifications/create", {
                body: `There was a problem - ${
                  err.response.data.error.message
                }`,
                type: "danger"
              });
            });
        }
      });
    }
  },

  components: {
    Dropdown,
    DropdownAction,
    TrAction
  },

  mixins: [VuetableFieldMixin]
};
</script>
